import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IChangedCustomElement } from '../html-elements';

@Component({
  selector: 'app-array-html-element',
  templateUrl: './array-html-element.component.html',
  styleUrls: ['./array-html-element.component.scss']
})
export class ArrayHtmlElementComponent {


  myGroup: FormGroup = new FormGroup({
    customElement: new FormControl(),
    customElementNombre: new FormControl(),
    customElementValue: new FormControl(),
  });

  @Input() idx;
  @Input() name;
  @Input() value;

  @Output() changed:EventEmitter<IChangedCustomElement> = new EventEmitter<IChangedCustomElement>();

  option: any[] = [];

  ngOnInit(): void {
    if (!this.value) {
      this.value = [];
    }
    // Inicializar el valor si viene del input
    if (this.value && Array.isArray(this.value)) {
      // El valor ya está inicializado
    }
  }

  /** Main label: prefer value (e.g. DNI, HOMBRE), then nombre, to avoid showing translation keys as title. */
  getItemDisplayName(item: any, index: number): string {
    if (item != null && item.value != null && item.value !== '') {
      return String(item.value);
    }
    if (item != null && item.nombre != null && item.nombre !== '') {
      return String(item.nombre);
    }
    return 'Item ' + (index + 1);
  }
  
  choosenElement(value: any) {
    this.option = value;
  }

  anadirItem() {
    const nombre = this.myGroup.get('customElementNombre').value?.trim();
    const value = this.myGroup.get('customElementValue').value?.trim();
    
    if (!nombre || !value) {
      return;
    }

    // Verificar si ya existe un item con el mismo nombre o valor
    const exists = this.value.some(item => 
      (item.nombre && item.nombre === nombre) || 
      (item.value && item.value === value)
    );

    if (exists) {
      // Podríamos mostrar un mensaje de error aquí
      return;
    }

    if (!this.value) {
      this.value = [];
    }
    
    this.value.push({nombre, value});
    this.clean();
    
    // Emitir cambio
    this.changed.emit({
      idx: this.idx,
      value: this.value
    });
  }

  removerItem() {
    const selectedIndex = this.myGroup.get('customElement').value;
    if (selectedIndex !== null && selectedIndex !== undefined && selectedIndex !== '') {
      const idx = parseInt(selectedIndex);
      if (idx >= 0 && idx < this.value.length) {
        this.value.splice(idx, 1);
        this.myGroup.patchValue({customElement: ''});
        this.option = null;
        
        // Emitir cambio
        this.changed.emit({
          idx: this.idx,
          value: this.value
        });
      }
    }
  }

  removerItemByIndex(index: number) {
    if (index >= 0 && index < this.value.length) {
      this.value.splice(index, 1);
      this.myGroup.patchValue({customElement: ''});
      this.option = null;
      
      // Emitir cambio
      this.changed.emit({
        idx: this.idx,
        value: this.value
      });
    }
  }

  clean() {
    this.myGroup.patchValue({customElementNombre: ''});
    this.myGroup.patchValue({customElementValue: ''});
  }

  OnChanged($event: any) {
    const selectedIndex = $event.value;
    if (selectedIndex !== null && selectedIndex !== undefined && selectedIndex !== '') {
      const idx = parseInt(selectedIndex);
      if (idx >= 0 && idx < this.value.length) {
        this.option = this.value[idx].value;
      }
    }
  }

}
